export default __webpack_public_path__ + "static/media/pic2.748e06b1.jpg";